import { createAction } from '@reduxjs/toolkit';

import {
  SocketConnectedPayload,
  SocketDisconnectedPayload,
} from 'src/v2/boundary/actionPayload/socket';

export const socketConnected = createAction<SocketConnectedPayload>('socket/connected');
export const socketDisconnected = createAction<SocketDisconnectedPayload>('socket/disconnected');
